// extracted by mini-css-extract-plugin
module.exports = {"container":"SelectAuthorProducts_container__DxcUh","searchButton":"SelectAuthorProducts_searchButton__1mQSg"};